import * as React from 'react';
import { Sector } from 'recharts';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const splitDonutTooltip: (props: any) => React.ReactElement<SVGElement> = (props) => {
  const { cx, cy, innerRadius, outerRadius, startAngle, endAngle, fill } = props;

  return (
    <g className="___donut-g">
      <Sector
        cx={cx}
        cy={cy}
        className="___donut-sect"
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />
    </g>
  );
};

export default splitDonutTooltip;
